import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Modal = ({ isOpen, onClose, title, children, footer, size = 'md' }) => {
  // Prevent scrolling on the body when the modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none">
      <div 
        className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity" 
        onClick={onClose}
      />
      <div className={`relative w-full ${sizeClasses[size]} mx-auto my-6 p-4 z-50 animate-fade-in`}>
        <div className="relative flex flex-col w-full bg-white border-0 rounded-2xl shadow-xl outline-none overflow-hidden">
          
          {/* Header */}
          <div className="flex items-center justify-between p-5 border-b border-solid border-slate-100 rounded-t-2xl bg-white">
            <h3 className="text-xl font-semibold text-slate-800 tracking-tight">
              {title}
            </h3>
            <button
              className="p-1 ml-auto bg-transparent border-0 text-slate-400 hover:text-slate-600 transition-colors float-right text-3xl leading-none font-semibold outline-none rounded-lg hover:bg-slate-100"
              onClick={onClose}
            >
              <X size={20} />
            </button>
          </div>
          
          {/* Body */}
          <div className="relative p-6 flex-auto max-h-[70vh] overflow-y-auto text-slate-600">
            {children}
          </div>
          
          {/* Footer */}
          {footer && (
            <div className="flex items-center justify-end p-5 border-t border-solid border-slate-100 rounded-b-2xl bg-slate-50/50">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
